<template>
  <div class="parent">
    <div class="search-result">
      <div class="search-functions-headers">
        <!-- <div class="search-functions" v-if="fileList.length > 0">
          <BBtnPrimary
            :img-src="require('@/assets/delete.png')"
            :clicked="deleteFile"
            btn-txt="所有文件清除"
            style="margin-top: 5px"
          />
        </div> -->
        <div class="search-functions">
          <BInputText
            label-text="天数"
            v-model="dayFrom"
            :maxLength="3"
            placeholder="请输入天数扫描文件"
          />
        </div>
        <div class="search-functions">
          <BBtnSecondary
            :img-src="require('@/assets/icon_screen.png')"
            :clicked="doScan"
            hidden-key="true"
            btn-txt="扫描"
            style="margin-left: 30px"
          />
        </div>
        <div class="search-functions">
          <label style="margin-top:12px;margin-left:10px;">文件总大小:</label>
          <span style="margin-top:12px;margin-left:5px;">{{totalFileSize === '' ? '0M' : totalFileSize}}</span>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="fileList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div class="btn-detail" @click="downloadFile(item.data)">打开</div>
            <div class="clean_single_file" @click="cleanSingleFile(item.data)">
              清除
            </div>
          </div>
        </template>
        <template v-slot:sizeAction="item">
          <div>
            {{ item.data.fileSize }}
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { searchList, deleteOneFile,fileScan } from "@/api/abandon";
// import { deleteFile } from "@/api/abandon";
import Table from "../../components2/Table";
// import BBtnPrimary from "../../components2/BBtnPrimary";
import Hub from '../../events/Hub';
// import PopupContents from "../../views2/sample/PopupContents";
import Vue from "vue";
import BBtnSecondary from "../../components2/BBtnSecondary";
import BInputText from "../../components2/BInputAbandonText";
export default {
  components: {Table,BBtnSecondary,BInputText, },
  data() {
    return {
      totalPages: 0,
      page: 1,
      limit: 10,
      totalCount: 0,
      loading: false,
      headers: [
        { text: "NO", value: "indexNum", sortable: false, align: "center", width: '4%' },
        { text: "文件夹", value: "folder", sortable: false, width: '20%', align: "center" },
        { text: "文件KEY", value: "fileKey", sortable: false, width: '40%', align: "center" },
        { text: "文件大小", value: "sizeAction", sortable: false, align: "center", width: '15%' },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      // 文件list
      fileList: [],
      data: {},
      deleteId: "",
      oprFlg: false,
      dayFrom: "",
      totalFileSize: '',
    };
  },
  created() {
    this.doSearch(true);
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  methods: {
    // 查询
     doSearch(flag) {
      if (flag) {
        this.totalPages = 0
        this.page = 1
        this.limit = 10
        this.totalCounts = 0
      }
      this.searchList()
    },
    async searchList (){
      this.loading = true;
      var param = {
        page: this.page,
        limit: this.limit,
      };
      const data = await searchList(param);
      if (data.data !== null || data.data === "") {
        if (data.data.searchList !== null || data.data.searchList === "") {
          this.fileList = data.data.searchList;
        }
        this.totalFileSize = data.data.fileTotalSize
        this.totalCount = data.data.totalPage;
        this.totalPages = Math.ceil(this.totalCount / this.limit);
      }
      this.loading = false;
    },
    // 全部文件删除
    // deleteFile() {
    //   this.data.bodyText = "该操作将会清除Obs上所有的废弃文件,清除后不可恢复,是否确认清除?";
    //   Hub.$emit("open-modal");
    //   Hub.$emit("set-modal-data", this.data.bodyText, "清除", PopupContents);
    // },
    // 确认删除
    // async delConfirm() {
    //   const data = await deleteFile();
    //   if (data.code === 0) { 
    //     Vue.prototype.$vsnackbar.show(data.data.msg);
    //     this.doSearch(true);
    //   } else {
    //     Vue.prototype.$vsnackbar.show(data.data.msg);
    //   }
    // },
    async deleteOne() {
      const data = await deleteOneFile(this.deleteId);
      if (data.code === 0) { 
        Vue.prototype.$vsnackbar.show(data.data.msg);
        this.doSearch(true);
      } else {
        Vue.prototype.$vsnackbar.show(data.data.msg);
      }
    },
    set(value) {
      if (value === 1) {
        if (this.deleteId !== null && this.deleteId !== '' && this.deleteId !== undefined && this.oprFlg) {
          this.deleteOne()
        } else {
          this.delConfirm()
        }
      }
    },
    // 文件下载
    downloadFile(data) {
      window.open(data.fileUrl)
    },
    cleanSingleFile(data) {
      // this.data.bodyText = "是否确认清除该文件?";
      this.deleteId = data.id;
      this.deleteOne();
      // this.oprFlg = true
      // Hub.$emit("open-modal");
      // Hub.$emit("set-modal-data", this.data.bodyText, "清除", PopupContents);

    },
    // 废弃文件扫描
    async doScan() {
      if (this.dayFrom === '' || this.dayFrom === null || this.dayFrom === undefined) {
        Vue.prototype.$vsnackbar.show("请输入天数");
      } else {
        this.loading = true;
        var param = {
          page: this.page,
          limit: this.limit,
          dayFrom: this.dayFrom,
        };
        const data = await fileScan(param)
        if (data.data.searchList !== null || data.data.searchList === "") {
          this.fileList = data.data.searchList;
        }
        this.dayFrom = ""
        this.totalFileSize = data.data.fileTotalSize
        this.totalCount = data.data.totalPage;
        this.totalPages = Math.ceil(this.totalCount / this.limit);
        this.loading = false;
      }
    },
  },
  destroyed() {
    Hub.$off('modal-confirm', this.set);
  },
  mounted() {
    this.$nextTick(function () {
      Hub.$on('modal-confirm', this.set);
    }.bind(this));
  },
};
</script>

<style scoped>
.main2 {
  position: relative;
  /*margin: 5px 30px 5px 30px;*/
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
}

.btn-detail {
  margin: 0 20px 0 0;
  color: #0171a3;
  cursor: pointer;
}

.clean_single_file {
  margin: 0 20px 0 0;
  color: #f5365c;
  cursor: pointer;
}

.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  /* justify-content: space-between; */
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

a {
  text-decoration: none;
}

.parent {
  margin-top: 1.5em;
}
</style>
